module.exports = __webpack_public_path__ + "static/benefits_one-04bed6f67a0eb069a139687c3e221cd4.png";